var _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 100,
    viewBox: "0 0 220 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(74, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.656 22.842L18.26 31.974c-1.892.63-1.892 3.42 0 4.05l9.132 3.044 3.044 9.132c.63 1.892 3.42 1.892 4.05 0l9.132-27.396a2.135 2.135 0 00-2.706-2.706z",
    fill: "#F2994A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 34a16 16 0 100-32 16 16 0 000 32zm0-2a14 14 0 100-28 14 14 0 000 28z",
    fill: "#027353",
    opacity: 0.2
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 85,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 24,
    fill: "#027353"
  }, "123Travel.ru")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3e4428489d01e839c923bf45f7def9bc.svg";
export { ForwardRef as ReactComponent };